import React from 'react';
import { PlaneIcon, CalendarIcon, ClockIcon } from 'lucide-react';
import { DatePicker } from './DateTimePicker';
interface FlightDetailsProps {
  flightType: 'departure' | 'arrival';
  setFlightType: (type: 'departure' | 'arrival') => void;
  airline: string;
  setAirline: (airline: string) => void;
  flightNumber: string;
  setFlightNumber: (number: string) => void;
  airport: string;
  setAirport: (airport: string) => void;
  flightDate: Date | null;
  setFlightDate: (date: Date | null) => void;
  flightTime: Date | null;
  setFlightTime: (time: Date | null) => void;
}
export const FlightDetails: React.FC<FlightDetailsProps> = ({
  flightType,
  setFlightType,
  airline,
  setAirline,
  flightNumber,
  setFlightNumber,
  airport,
  setAirport,
  flightDate,
  setFlightDate,
  flightTime,
  setFlightTime
}) => {
  const airports = ['Changi T1', 'Changi T2', 'Changi T3', 'Changi T4'];
  const airlines = ['Singapore Airlines', 'AirAsia', 'Malaysia Airlines', 'Scoot', 'Jetstar'];
  return <div className="space-y-4" data-id="element-59">
      <div className="bg-card border border-primary border-opacity-30 rounded-lg p-4" data-id="element-60">
        <div className="flex items-center mb-4" data-id="element-61">
          <PlaneIcon size={18} className="text-primary mr-2" data-id="element-62" />
          <h3 className="font-medium" data-id="element-63">Flight Information</h3>
        </div>
        <div className="flex mb-4 bg-background rounded-lg p-1" data-id="element-64">
          <button className={`flex-1 py-2 rounded-md text-center text-sm ${flightType === 'departure' ? 'bg-primary text-background' : ''}`} onClick={() => setFlightType('departure')} data-id="element-65">
            Departure
          </button>
          <button className={`flex-1 py-2 rounded-md text-center text-sm ${flightType === 'arrival' ? 'bg-primary text-background' : ''}`} onClick={() => setFlightType('arrival')} data-id="element-66">
            Arrival
          </button>
        </div>
        <div className="space-y-3" data-id="element-67">
          <div data-id="element-68">
            <label className="text-sm text-white text-opacity-70 mb-2 block" data-id="element-69">
              Airline
            </label>
            <select className="input-field w-full" value={airline} onChange={e => setAirline(e.target.value)} data-id="element-70">
              <option value="" data-id="element-71">Select airline</option>
              {airlines.map(a => <option key={a} value={a} data-id="element-72">
                  {a}
                </option>)}
            </select>
          </div>
          <div data-id="element-73">
            <label className="text-sm text-white text-opacity-70 mb-2 block" data-id="element-74">
              Flight Number
            </label>
            <input type="text" className="input-field w-full" placeholder="e.g., SQ123" value={flightNumber} onChange={e => setFlightNumber(e.target.value)} data-id="element-75" />
          </div>
          <div data-id="element-76">
            <label className="text-sm text-white text-opacity-70 mb-2 block" data-id="element-77">
              Terminal
            </label>
            <select className="input-field w-full" value={airport} onChange={e => setAirport(e.target.value)} data-id="element-78">
              <option value="" data-id="element-79">Select terminal</option>
              {airports.map(a => <option key={a} value={a} data-id="element-80">
                  {a}
                </option>)}
            </select>
          </div>
          <div data-id="element-81">
            <label className="flex items-center text-sm text-white text-opacity-70 mb-2" data-id="element-82">
              <CalendarIcon size={16} className="text-primary mr-2" data-id="element-83" />
              Flight Date
            </label>
            <DatePicker selected={flightDate} onChange={setFlightDate} minDate={new Date()} dateFormat="MMMM d, yyyy" className="input-field w-full" placeholderText="Select date" data-id="element-84" />
          </div>
          <div data-id="element-85">
            <label className="flex items-center text-sm text-white text-opacity-70 mb-2" data-id="element-86">
              <ClockIcon size={16} className="text-primary mr-2" data-id="element-87" />
              Flight Time (SG Time)
            </label>
            <DatePicker selected={flightTime} onChange={setFlightTime} showTimeSelect showTimeSelectOnly timeIntervals={15} timeCaption="Time" dateFormat="h:mm aa" className="input-field w-full" placeholderText="Select time" data-id="element-88" />
          </div>
        </div>
      </div>
    </div>;
};